import { Capacitor } from '@capacitor/core';

/**
 * Dev-only escape hatch to preview the native / mobile-exclusive UI in a desktop
 * browser without a device. Append `?native=1` to any URL once — it persists via
 * localStorage so it survives navigation — and `?native=0` turns it back off.
 * Gated on NODE_ENV so it can never flip the real production/web app to native.
 */
function devForcedNative(): boolean {
  if (process.env.NODE_ENV !== 'development' || typeof window === 'undefined') {
    return false;
  }
  try {
    const param = new URLSearchParams(window.location.search).get('native');
    if (param === '1') localStorage.setItem('rf-force-native', '1');
    if (param === '0') localStorage.removeItem('rf-force-native');
    return localStorage.getItem('rf-force-native') === '1';
  } catch {
    return false;
  }
}

export function isNativePlatform(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return Capacitor.isNativePlatform() || devForcedNative();
}
